export default "__VITE_ASSET__4148a8d5__"